// Task Progress Modal - отображение прогресса фоновых задач

import React from 'react';
import { getFullUrlWithTimestamp } from '../../services/api';
import type { BackgroundTask } from '../../types';

interface TaskProgressModalProps {
  isOpen: boolean;
  taskName: string;
  progress: number;
  task: BackgroundTask | null;
  onClose: () => void;
  onAccept: () => void;
  onRetry?: () => void;
}

const TaskProgressModal: React.FC<TaskProgressModalProps> = ({
  isOpen,
  taskName,
  progress,
  task,
  onClose,
  onAccept,
  onRetry,
}) => {
  if (!isOpen) return null;

  const isCompleted = task?.status === 'completed';
  const isFailed = task?.status === 'failed';

  return (
    <div className="modal-overlay" style={{ zIndex: 1500 }}>
      <div className="modal-content" style={{ zIndex: 1501 }}>
        <div className="modal-header">
          <h3>{taskName}</h3>
          <button className="modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }}></div>
        </div>

        <div className="task-status" style={{ textAlign: 'center', margin: '10px 0', fontWeight: 500 }}>
          {isFailed
            ? `Failed: ${task.error || 'Unknown error'}`
            : isCompleted
              ? 'Completed!'
              : 'Processing...'}
        </div>

        {isCompleted && task.result && (
          <div id="task-result">
            {(task.result.image_url || task.result.first_frame_url || task.result.edit_url) && (
              <img
                src={getFullUrlWithTimestamp(task.result.image_url || task.result.first_frame_url || task.result.edit_url)}
                alt="Result"
                style={{ maxWidth: '100%', borderRadius: '8px', margin: '10px 0' }}
              />
            )}
            {(task.result.video_url || task.result.output_url) && (
              <video
                src={getFullUrlWithTimestamp(task.result.video_url || task.result.output_url)}
                controls
                style={{ width: '100%', maxWidth: '500px', margin: '10px auto', borderRadius: '8px', display: 'block' }}
              />
            )}
            {task.result.audio_url && (
              <audio
                src={getFullUrlWithTimestamp(task.result.audio_url)}
                controls
                style={{ width: '100%', maxWidth: '500px', margin: '10px auto', display: 'block' }}
              />
            )}
            <div className="generation-actions" style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap', marginTop: '15px' }}>
              <button onClick={onAccept} className="btn btn-primary">
                Accept
              </button>
              {onRetry && (
                <button onClick={onRetry} className="btn btn-warning">
                  Retry
                </button>
              )}
            </div>
          </div>
        )}

        {isFailed && onRetry && (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <button onClick={onRetry} className="btn btn-warning">
              Retry
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaskProgressModal;
